var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "feesForPaidPassengersMasterForm",
      staticClass: "fees-for-paid-passengers-master-form",
      attrs: {
        model: _vm.model,
        rules: _vm.rules,
        "label-width": "12.5em",
        "label-position": "left"
      }
    },
    [
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("ChargeYear", {
            attrs: {
              label: "料金年度",
              prop: "charge_year",
              yearType: "reference",
              required: true,
              searchCond: true,
              disabled: _vm.editMode,
              autofocus: !_vm.editMode,
              initialize: true,
              tableType: _vm.tableType,
              mode: "this"
            },
            model: {
              value: _vm.chargeYear,
              callback: function($$v) {
                _vm.chargeYear = $$v
              },
              expression: "chargeYear"
            }
          }),
          _c("Select", {
            attrs: {
              label: "線別",
              prop: "route_code",
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              disabled: _vm.editMode,
              codeId: "ROUTE_CODE",
              initialize: true
            },
            model: {
              value: _vm.routeCode,
              callback: function($$v) {
                _vm.routeCode = $$v
              },
              expression: "routeCode"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("Select", {
            attrs: {
              label: "ジェット区分",
              prop: "jet_type",
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              disabled: _vm.editMode,
              codeId: "JET_TYPE",
              initialize: true
            },
            model: {
              value: _vm.jetType,
              callback: function($$v) {
                _vm.jetType = $$v
              },
              expression: "jetType"
            }
          }),
          _c("Select", {
            attrs: {
              label: "有償区分",
              prop: "paid_type",
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              disabled: _vm.editMode,
              codeId: "PAID_TYPE",
              initialize: true
            },
            model: {
              value: _vm.paidType,
              callback: function($$v) {
                _vm.paidType = $$v
              },
              expression: "paidType"
            }
          })
        ],
        1
      ),
      _c("el-divider"),
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("Numeric", {
            attrs: {
              label: "単価",
              prop: "charge",
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              min: 0,
              max: 9999,
              step: 1,
              disabled: _vm.editDisabledMode && _vm.editMode
            },
            model: {
              value: _vm.charge,
              callback: function($$v) {
                _vm.charge = $$v
              },
              expression: "charge"
            }
          }),
          _c("Numeric", {
            attrs: {
              label: "最大利用座席割合[%]",
              prop: "max_passengers_rate",
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              min: 0,
              max: 100,
              step: 1,
              disabled: _vm.editDisabledMode && _vm.editMode
            },
            model: {
              value: _vm.maxPassengersRate,
              callback: function($$v) {
                _vm.maxPassengersRate = $$v
              },
              expression: "maxPassengersRate"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("el-col", { staticClass: "caution" }, [
            _vm._v(
              " ※減免率は着陸料金マスタ[重量・騒音]で設定したものが適用されます。 "
            )
          ])
        ],
        1
      ),
      _vm.formMode === "edit"
        ? [
            _c("el-divider"),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("DateTime", {
                  attrs: {
                    label: "更新日時",
                    prop: "updated_on",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    disabled: _vm.editMode,
                    format: "yyyy/MM/dd HH:mm:ss"
                  },
                  model: {
                    value: _vm.updatedOn,
                    callback: function($$v) {
                      _vm.updatedOn = $$v
                    },
                    expression: "updatedOn"
                  }
                }),
                _c("Blank")
              ],
              1
            )
          ]
        : _vm._e(),
      _c("el-divider")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }